import { Vector2 } from "../utils/vector2.ts";

export const Vfx = (function () {
    // boiler plate class
    return class Vfx {
        constructor () {

        }

        render (context: CanvasRenderingContext2D, offset: Vector2, scale: number): void {

        }
    }
})();